// Casing for name tokens that read as acronyms rather than words.
const ACRONYMS = {
	'4k': '4K',
	ada: 'ADA',
	api: 'API',
	css: 'CSS',
	id: 'ID',
	json: 'JSON',
	ui: 'UI',
	url: 'URL',
	uuid: 'UUID',
	vcl: 'VCL',
};

/**
 * Fallback display label for a setting with no curated display_name:
 * title-cases the raw snake_case name, e.g. "animation_start_phase" ->
 * "Animation Start Phase", "venue_id" -> "Venue ID". A curated
 * display_name always takes precedence at the call sites.
 * @param {string} name - raw setting name (snake_case)
 * @returns {string} - human-readable label
 */
export const humanizeSettingName = (name) => {
	if (!name) return '';
	return String(name)
		.split('_')
		.filter(Boolean)
		.map((word) => {
			const lower = word.toLowerCase();
			// own-property check: a token like "constructor" must not hit the prototype chain
			return Object.prototype.hasOwnProperty.call(ACRONYMS, lower)
				? ACRONYMS[lower]
				: word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join(' ');
};
